module.exports = __webpack_public_path__ + "static/media/Bay4.367bbe83.JPG";